import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';

import {
  resetOptinMessage,
  OPTIN_MESSAGE_DEFAULT,
  OPTIN_MESSAGE_SUCCESS,
  OPTIN_MESSAGE_ERROR,
} from 'Redux/ducks/optin-message';
import Meta from 'Components/Utility/SEO/Meta';
import NoIndex from 'Components/Utility/SEO/NoIndex';
import { history } from 'Redux/store';

const messages = defineMessages({
  title: {
    id: 'optin.title',
    defaultMessage: 'Optin to promotional messages',
  },
  optin_confirm: {
    id: 'optin.optin-confirm',
    defaultMessage: 'Thank you. Your optin request is being processed',
  },
  optin_error: {
    id: 'optin.optin-error',
    defaultMessage: 'Sorry your optin has not been processed please try again later',
  },
});

const Optin = ({
  optinConfirm,
  optin,
  match,
}) => {
  const { formatMessage } = useIntl();
  const [disableButton, setDisableButton] = useState(false);
  const token = match.params.token;

  const handleConfirm = async () => {
    setDisableButton(true);
    resetOptinMessage();
    await optinConfirm(token);
    setDisableButton(false);
  };

  useEffect(() => {
    const doConfirm = async () => {
      setDisableButton(true);
      resetOptinMessage();
      await optinConfirm(token);
      setDisableButton(false);
    };

    doConfirm();
  }, [token, optinConfirm]);

  let showButton = false;

  if (!showButton && optin?.status === OPTIN_MESSAGE_ERROR) {
    showButton = true;
  }
  const showReturnButton = optin?.status === OPTIN_MESSAGE_SUCCESS ||
      optin?.status === OPTIN_MESSAGE_ERROR;

  return (
    <React.Fragment>
      <Meta brandTitle title={formatMessage(messages.title)} />
      <NoIndex />
      <div className="fanatical-general-page">
        <div className="container">
          <div className="fanatical-general-page-content">
            <h1>
              <FormattedMessage id="opin.request" defaultMessage="Email Newsletter Confirmation." />
            </h1>
            <hr />
            {optin?.status === OPTIN_MESSAGE_ERROR &&
            <p>
              {formatMessage(messages.optin_error)}
            </p>
              }
            {optin?.status === OPTIN_MESSAGE_SUCCESS &&
            <p>
              {formatMessage(messages.optin_confirm)}
            </p>
              }
            <div className="cta-group-container mt-4">
              {showButton &&
              <div className="cta-container">
                <button className="btn btn-primary" disabled={disableButton} onClick={handleConfirm}>
                  <FormattedMessage id="opin.conform" defaultMessage="Confirm Email Double Opt-In" />
                </button>
              </div>
                }
              {showReturnButton &&
              <div className="cta-container">
                <button className="btn btn-secondary" onClick={() => { history.push('/'); }}>
                  <FormattedMessage id="optin.return-homepage" defaultMessage="Return to the Homepage" />
                </button>
              </div>
                }
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

Optin.propTypes = {
  optinConfirm: PropTypes.func,
  optin: PropTypes.shape({
    status: PropTypes.string,
    message: PropTypes.string,
    data: PropTypes.shape({}),
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      token: PropTypes.string,
    }),
  }),
};

Optin.defaultProps = {
  optinConfirm: () => {},
  optin: {
    status: OPTIN_MESSAGE_DEFAULT,
    message: '',
    data: {},
  },
  match: {
    params: {
      token: '',
    },
  },
};

export default Optin;
